import { useLocation } from 'react-router';
import qs from 'query-string';

import { QUERY_SELECTED_CHIP_KEY, QUERY_SELECTED_CHIP_TAG_KEY } from '@/modules/common/constants/queryParams';

import { safetyJsonParse } from '../../../helpers/request';

export const useSelectedChipFromQuery = () => {
  const location = useLocation();

  const queryChipObj = qs.parse(location.search)[QUERY_SELECTED_CHIP_KEY] as string | undefined;
  const { [QUERY_SELECTED_CHIP_TAG_KEY]: selectedChipFromQuery } = safetyJsonParse(queryChipObj || '');

  return selectedChipFromQuery;
};
